import React, {useState,useEffect} from 'react'
import styled from "styled-components"
import  {useHistory}  from 'react-router-dom'
import "./MainMenu.css"

const Container = styled.div`
    background: radial-gradient(circle, rgba(20,30,48,1) 0%, rgba(36,59,85,1) 100%);
    position:absolute;
    width:100%;
    height:100%;
    top:0;
    left:0;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow-y: auto;
    overflow-x: hidden;
    
    /* Centraliza no PC, alinha no topo no Mobile para evitar corte */
    justify-content: center;
    
    @media (max-width: 768px) {
        justify-content: flex-start;
        padding-top: 50px;
    }
`

const MainMenu = () => {
	const [style, setStyle] = useState();
	const history = useHistory();
	
	useEffect(() => {
		setTimeout(()=>{
			setStyle("nav-active");
			const firstItem = document.querySelector(".menu-circle");
            if(firstItem) firstItem.focus();
		},100)
    },[]);

	const redirect = (page) =>{
		setStyle("nav-closing");
		setTimeout(()=>{
			history.push(page)
        },500)
	}

	const moveFocus = (e) => {
        const active = document.activeElement;
        if (e.keyCode === 39 && active.parentElement.nextSibling) { // Direita
            active.parentElement.nextSibling.querySelector('button').focus();
        } else if (e.keyCode === 37 && active.parentElement.previousSibling) { // Esquerda
            active.parentElement.previousSibling.querySelector('button').focus();
        }
    }
	
    return (
        <Container className={style}>
            {/* Logo Central ao Fundo (Opcional) */}
            <div className="bg-logo-container">
                <img src="img/logo_pro.png" alt="Logo" className="bg-logo-fade" />
            </div>

            <div className="menu-wrapper">
                <div className="menu-circles-container" onKeyDown={moveFocus}>
                    
                    {/* CANAIS */}
                    <div className="menu-item-box">
                        <button className="menu-circle" onClick={() => redirect("/live/category/")} style={{backgroundImage: 'url("https://images.unsplash.com/photo-1594909122845-11baa439b7bf?q=80&w=400&h=400&fit=crop")'}}>
                            <div className="circle-overlay"></div>
                        </button>
                        <span className="menu-label">CANAIS AO VIVO</span>
                    </div>

                    {/* FILMES */}
                    <div className="menu-item-box">
                        <button className="menu-circle" onClick={() => redirect("/movie/")} style={{backgroundImage: 'url("https://images.unsplash.com/photo-1485846234645-a62644f84728?q=80&w=400&h=400&fit=crop")'}}>
                            <div className="circle-overlay"></div>
                        </button>
                        <span className="menu-label">FILMES</span>
                    </div>

                    {/* SÉRIES */}
                    <div className="menu-item-box">
                        <button className="menu-circle" onClick={() => redirect("/series/")} style={{backgroundImage: 'url("https://images.unsplash.com/photo-1522869635100-9f4c5e86aa37?q=80&w=400&h=400&fit=crop")'}}>
                            <div className="circle-overlay"></div>
                        </button>
                        <span className="menu-label">SÉRIES</span>
                    </div>

                </div>
            </div>

            {/* RODAPÉ (CONTA E AJUSTES) */}
            <div className="footer-menu">
                <div className="footer-item left" onClick={() => redirect("/info/")}>
                    <button className="footer-btn">
                        <i className="fas fa-user-circle"></i>
                        <span>MINHA CONTA</span>
                    </button>
                </div>
                <div className="footer-item right" onClick={() => redirect("/info/")}>
                    <button className="footer-btn">
                        <i className="fas fa-cog"></i>
                        <span>AJUSTES</span>
                    </button>
                </div>
            </div>
        </Container>
    )
}

export default MainMenu
